import React from "react"

const icons = {
	rss: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M6 5c7.18 0 13 5.82 13 13M6 11a7 7 0 017 7m-6 0a1 1 0 11-2 0 1 1 0 012 0z"
			/>
		</svg>
	),
	search: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
			/>
		</svg>
	),
	love: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
			/>
		</svg>
	),
	loveFill: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20"
			fill="currentColor"
			height="100%"
			width="100%">
			<path
				fillRule="evenodd"
				d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
				clipRule="evenodd"
			/>
		</svg>
	),
	chat: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
			/>
		</svg>
	),
	twitter: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			height="100%"
			width="100%">
			<path fill="none" d="M0 0h24v24H0z" />
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M15.3 5.55a2.9 2.9 0 0 0-2.9 2.847l-.028 1.575a.6.6 0 0 1-.68.583l-1.561-.212c-2.054-.28-4.022-1.226-5.91-2.799-.598 3.31.57 5.603 3.383 7.372l1.747 1.098a.6.6 0 0 1 .034.993L7.793 18.17c.947.059 1.846.017 2.592-.131 4.718-.942 7.855-4.492 7.855-10.348 0-.478-1.012-2.141-2.94-2.141zm-4.9 2.81a4.9 4.9 0 0 1 8.385-3.355c.711-.005 1.316.175 2.669-.645-.335 1.64-.5 2.352-1.214 3.331 0 7.642-4.697 11.358-9.463 12.309-3.268.652-8.02-.419-9.382-1.841.694-.054 3.514-.357 5.144-1.55C5.16 15.7-.329 12.47 3.278 3.786c1.693 1.977 3.41 3.323 5.15 4.037 1.158.475 1.442.465 1.973.538z"
				fill="currentColor"
			/>
		</svg>
	),
	twitterX: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M8 2H1L9.26086 13.0145L1.44995 21.9999H4.09998L10.4883 14.651L16 22H23L14.3917 10.5223L21.8001 2H19.1501L13.1643 8.88578L8 2ZM17 20L5 4H7L19 20H17Z" />
		</svg>
	),
	email: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
			/>
		</svg>
	),
	github: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			height="100%"
			width="100%">
			<path fill="none" d="M0 0h24v24H0z" />
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M12 2C6.475 2 2 6.475 2 12a9.994 9.994 0 0 0 6.838 9.488c.5.087.687-.213.687-.476 0-.237-.013-1.024-.013-1.862-2.512.463-3.162-.612-3.362-1.175-.113-.288-.6-1.175-1.025-1.413-.35-.187-.85-.65-.013-.662.788-.013 1.35.725 1.538 1.025.9 1.512 2.338 1.087 2.912.825.088-.65.35-1.087.638-1.337-2.225-.25-4.55-1.113-4.55-4.938 0-1.088.387-1.987 1.025-2.688-.1-.25-.45-1.275.1-2.65 0 0 .837-.262 2.75 1.026a9.28 9.28 0 0 1 2.5-.338c.85 0 1.7.112 2.5.337 1.912-1.3 2.75-1.024 2.75-1.024.55 1.375.2 2.4.1 2.65.637.7 1.025 1.587 1.025 2.687 0 3.838-2.337 4.688-4.562 4.938.362.312.675.912.675 1.85 0 1.337-.013 2.412-.013 2.75 0 .262.188.574.688.474A10.016 10.016 0 0 0 22 12c0-5.525-4.475-10-10-10z"
				fill="currentColor"
			/>
		</svg>
	),
	right: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M14 5l7 7m0 0l-7 7m7-7H3"
			/>
		</svg>
	),
	chevronRight: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor"
			height="100%"
			width="100%">
			<path
				fillRule="evenodd"
				d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z"
				clipRule="evenodd"
			/>
		</svg>
	),
	me: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
			/>
		</svg>
	),
	sticky: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M9 11l3-3m0 0l3 3m-3-3v8m0-13a9 9 0 110 18 9 9 0 010-18z"
			/>
		</svg>
	),
	cate: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"
			/>
		</svg>
	),
	preview: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"
			/>
		</svg>
	),
	empty: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
			/>
		</svg>
	),
	subscribe: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M16 4v12l-4-2-4 2V4M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
			/>
		</svg>
	),
	left: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
			/>
		</svg>
	),
	count: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
			/>
		</svg>
	),
	play: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
			/>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
			/>
		</svg>
	),
	pause: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
			/>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"
			/>
		</svg>
	),
	pages: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
			/>
		</svg>
	),
	comments: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
			/>
		</svg>
	),
	home: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
			/>
		</svg>
	),
	toc: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M4 6h16M4 12h16M4 18h7"
			/>
		</svg>
	),
	leftPlain: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M10 19l-7-7m0 0l7-7m-7 7h18"
			/>
		</svg>
	),
	mic: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			height="100%"
			width="100%">
			<path fill="none" d="M0 0h24v24H0z" />
			<path
				fill="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M12 13l6 9H6l6-9zm-1.06-2.44a1.5 1.5 0 1 1 2.12-2.12 1.5 1.5 0 0 1-2.12 2.12zM5.281 2.783l1.415 1.415a7.5 7.5 0 0 0 0 10.606l-1.415 1.415a9.5 9.5 0 0 1 0-13.436zm13.436 0a9.5 9.5 0 0 1 0 13.436l-1.415-1.415a7.5 7.5 0 0 0 0-10.606l1.415-1.415zM8.11 5.611l1.414 1.414a3.5 3.5 0 0 0 0 4.95l-1.414 1.414a5.5 5.5 0 0 1 0-7.778zm7.778 0a5.5 5.5 0 0 1 0 7.778l-1.414-1.414a3.5 3.5 0 0 0 0-4.95l1.414-1.414z"
			/>
		</svg>
	),
	githubLine: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			height="100%"
			width="100%">
			<path fill="none" d="M0 0h24v24H0z" />
			<path
				fill="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M5.883 18.653c-.3-.2-.558-.455-.86-.816a50.32 50.32 0 0 1-.466-.579c-.463-.575-.755-.84-1.057-.949a1 1 0 0 1 .676-1.883c.752.27 1.261.735 1.947 1.588-.094-.117.34.427.433.539.19.227.33.365.44.438.204.137.587.196 1.15.14.023-.382.094-.753.202-1.095C5.38 15.31 3.7 13.396 3.7 9.64c0-1.24.37-2.356 1.058-3.292-.218-.894-.185-1.975.302-3.192a1 1 0 0 1 .63-.582c.081-.024.127-.035.208-.047.803-.123 1.937.17 3.415 1.096A11.731 11.731 0 0 1 12 3.315c.912 0 1.818.104 2.684.308 1.477-.933 2.613-1.226 3.422-1.096.085.013.157.03.218.05a1 1 0 0 1 .616.58c.487 1.216.52 2.297.302 3.19.691.936 1.058 2.045 1.058 3.293 0 3.757-1.674 5.665-4.642 6.392.125.415.19.879.19 1.38a300.492 300.492 0 0 1-.012 2.716 1 1 0 0 1-.019 1.958c-1.139.228-1.983-.532-1.983-1.525l.002-.446.005-.705c.005-.708.007-1.338.007-1.998 0-.697-.183-1.152-.425-1.36-.661-.57-.326-1.655.54-1.752 2.967-.333 4.337-1.482 4.337-4.66 0-.955-.312-1.744-.913-2.404a1 1 0 0 1-.19-1.045c.166-.414.237-.957.096-1.614l-.01.003c-.491.139-1.11.44-1.858.949a1 1 0 0 1-.833.135A9.626 9.626 0 0 0 12 5.315c-.89 0-1.772.119-2.592.35a1 1 0 0 1-.83-.134c-.752-.507-1.374-.807-1.868-.947-.144.653-.073 1.194.092 1.607a1 1 0 0 1-.189 1.045C6.016 7.89 5.7 8.694 5.7 9.64c0 3.172 1.371 4.328 4.322 4.66.865.097 1.201 1.177.544 1.748-.192.168-.429.732-.429 1.364v3.15c0 .986-.835 1.725-1.96 1.528a1 1 0 0 1-.04-1.962v-.99c-.91.061-1.662-.088-2.254-.485z"
			/>
		</svg>
	),
	alipay: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			height="100%"
			width="100%">
			<path fill="none" d="M0 0h24v24H0z" />
			<path
				fill="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M18.408 16.79c-2.173-.95-3.72-1.646-4.64-2.086-1.4 1.696-2.872 2.72-5.08 2.72S5 16.064 5.176 14.392c.12-1.096.872-2.888 4.128-2.576 1.72.16 2.504.48 3.912.944.36-.664.664-1.4.888-2.176H7.88v-.616h3.072V8.864H7.2v-.68h3.752V6.592s.032-.248.312-.248H12.8v1.848h4v.68h-4v1.104h3.264a12.41 12.41 0 0 1-1.32 3.32c.51.182 2.097.676 4.76 1.483a8 8 0 1 0-1.096 2.012zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-3.568-5.632c1.44 0 2.824-.872 3.96-2.352-1.608-.776-2.944-1.16-4.44-1.16-1.304 0-1.984.8-2.104 1.416-.12.616.248 2.096 2.584 2.096z"
			/>
		</svg>
	),
	wxpay: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			height="100%"
			width="100%">
			<path fill="none" d="M0 0h24v24H0z" />
			<path
				fill="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M19.145 8.993l-9.799 5.608-.07.046a.646.646 0 0 1-.3.068.655.655 0 0 1-.58-.344l-.046-.092-1.83-3.95c-.024-.046-.024-.092-.024-.138 0-.184.139-.321.324-.321.07 0 .14.023.209.069l2.155 1.515c.162.092.348.161.556.161a.937.937 0 0 0 .348-.069l8.275-3.648C16.934 6.273 14.634 5.2 12 5.2c-4.42 0-7.9 3.022-7.9 6.6 0 1.366.5 2.673 1.432 3.781.048.057.12.137.214.235a4 4 0 0 1 1.101 3.102l-.025.297.716-.436a4 4 0 0 1 2.705-.536c.212.033.386.059.52.076.406.054.82.081 1.237.081 4.42 0 7.9-3.022 7.9-6.6 0-.996-.27-1.95-.755-2.807zM6.192 21.943a1 1 0 0 1-1.526-.932l.188-2.259a2 2 0 0 0-.55-1.551A6.993 6.993 0 0 1 4 16.868C2.806 15.447 2.1 13.695 2.1 11.8c0-4.75 4.432-8.6 9.9-8.6s9.9 3.85 9.9 8.6-4.432 8.6-9.9 8.6c-.51 0-1.01-.033-1.499-.098a23.61 23.61 0 0 1-.569-.084 2 2 0 0 0-1.353.268l-2.387 1.456z"
			/>
		</svg>
	),
	bitcoin: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			height="100%"
			width="100%">
			<path fill="none" d="M0 0h24v24H0z" />
			<path
				fill="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-4H8V8h3V6h2v2h1a2.5 2.5 0 0 1 2 4 2.5 2.5 0 0 1-2 4h-1v2h-2v-2zm-1-3v1h4a.5.5 0 1 0 0-1h-4zm0-3v1h4a.5.5 0 1 0 0-1h-4z"
			/>
		</svg>
	),
	question: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
			/>
		</svg>
	),
	people: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
			/>
		</svg>
	),
	growth: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
			/>
		</svg>
	),
	microphone: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
			/>
		</svg>
	),
	sun: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
			/>
		</svg>
	),
	moon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
			/>
		</svg>
	),
	lightBulb: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
			/>
		</svg>
	),
	star: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
			/>
		</svg>
	),
	eye: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
			/>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
			/>
		</svg>
	),
	global: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
			/>
		</svg>
	),
	users: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
			/>
		</svg>
	),
	userAdd: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
			/>
		</svg>
	),
	flag: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9"
			/>
		</svg>
	),
	thumbDown: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17 13V4m-7 10h2m5-10h2a2 2 0 012 2v6a2 2 0 01-2 2h-2.5"
			/>
		</svg>
	),
	plane: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
			/>
		</svg>
	),
	ppt: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M8 13v-1m4 1v-3m4 3V8M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
			/>
		</svg>
	),
	chatRounded: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
			/>
		</svg>
	),
	presentation: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path fill="none" d="M0 0h24v24H0z"></path>
			<path d="M8 4C8 5.10457 7.10457 6 6 6 4.89543 6 4 5.10457 4 4 4 2.89543 4.89543 2 6 2 7.10457 2 8 2.89543 8 4ZM5 16V22H3V10C3 8.34315 4.34315 7 6 7 6.82059 7 7.56423 7.32946 8.10585 7.86333L10.4803 10.1057 12.7931 7.79289 14.2073 9.20711 10.5201 12.8943 9 11.4587V22H7V16H5ZM6 9C5.44772 9 5 9.44772 5 10V14H7V10C7 9.44772 6.55228 9 6 9ZM19 5H10V3H20C20.5523 3 21 3.44772 21 4V15C21 15.5523 20.5523 16 20 16H16.5758L19.3993 22H17.1889L14.3654 16H10V14H19V5Z"></path>
		</svg>
	),
	money: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
			/>
		</svg>
	),
	checkDouble: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z" />
		</svg>
	),
	checkCircle: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20"
			fill="currentColor"
			height="100%"
			width="100%">
			<path
				fillRule="evenodd"
				d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
				clipRule="evenodd"
			/>
		</svg>
	),
	warningCircle: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20"
			fill="currentColor"
			height="100%"
			width="100%">
			<path
				fillRule="evenodd"
				d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
				clipRule="evenodd"
			/>
		</svg>
	),
	reply: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="h-5 w-5"
			viewBox="0 0 20 20"
			fill="currentColor"
			height="100%"
			width="100%">
			<path
				fillRule="evenodd"
				d="M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
				clipRule="evenodd"
			/>
		</svg>
	),
	arrowUp: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M5 15l7-7 7 7"
			/>
		</svg>
	),
	gear: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
			/>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
			/>
		</svg>
	),
	refresh: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
			/>
		</svg>
	),
	monitor: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
			/>
		</svg>
	),
	briefCase: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
			/>
		</svg>
	),
	eth: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			preserveAspectRatio="xMidYMid meet"
			viewBox="0 0 24 24"
			height="100%"
			width="100%">
			<rect x="0" y="0" width="24" height="24" fill="none" stroke="none" />
			<path
				fill="currentColor"
				d="m12 1.75l-6.25 10.5L12 16l6.25-3.75L12 1.75M5.75 13.5L12 22.25l6.25-8.75L12 17.25L5.75 13.5Z"
			/>
		</svg>
	),
	solana: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			stroke="currentColor"
			viewBox="0 0 508.07 390.17"
			className="scale-75"
			height="100%"
			width="100%">
			<path
				d="M84.53,358.89A16.63,16.63,0,0,1,96.28,354H501.73a8.3,8.3,0,0,1,5.87,14.18l-80.09,80.09a16.61,16.61,0,0,1-11.75,4.86H10.31A8.31,8.31,0,0,1,4.43,439Z"
				transform="translate(-1.98 -55)"
				fill="currentColor"
			/>
			<path
				d="M84.53,59.85A17.08,17.08,0,0,1,96.28,55H501.73a8.3,8.3,0,0,1,5.87,14.18l-80.09,80.09a16.61,16.61,0,0,1-11.75,4.86H10.31A8.31,8.31,0,0,1,4.43,140Z"
				transform="translate(-1.98 -55)"
				fill="currentColor"
			/>
			<path
				d="M427.51,208.42a16.61,16.61,0,0,0-11.75-4.86H10.31a8.31,8.31,0,0,0-5.88,14.18l80.1,80.09a16.6,16.6,0,0,0,11.75,4.86H501.73a8.3,8.3,0,0,0,5.87-14.18Z"
				transform="translate(-1.98 -55)"
				fill="currentColor"
			/>
		</svg>
	),
	openSea: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			className="scale-90 opacity-50 dark:opacity-[0.6] dark:invert"
			height="100%"
			width="100%">
			<path d="M12 0C5.374 0 0 5.374 0 12s5.374 12 12 12 12-5.374 12-12S18.629 0 12 0ZM5.92 12.403l.051-.081 3.123-4.884a.107.107 0 0 1 .187.014c.52 1.169.972 2.623.76 3.528-.088.372-.335.876-.614 1.342a2.405 2.405 0 0 1-.117.199.106.106 0 0 1-.09.045H6.013a.106.106 0 0 1-.091-.163zm13.914 1.68a.109.109 0 0 1-.065.101c-.243.103-1.07.485-1.414.962-.878 1.222-1.548 2.97-3.048 2.97H9.053a4.019 4.019 0 0 1-4.013-4.028v-.072c0-.058.048-.106.108-.106h3.485c.07 0 .12.063.115.132-.026.226.017.459.125.67.206.42.636.682 1.099.682h1.726v-1.347H9.99a.11.11 0 0 1-.089-.173l.063-.09c.16-.231.391-.586.621-.992.156-.274.308-.566.43-.86.024-.052.043-.107.065-.16.033-.094.067-.182.091-.269a4.57 4.57 0 0 0 .065-.223c.057-.25.081-.514.081-.787 0-.108-.004-.221-.014-.327-.005-.117-.02-.235-.034-.352a3.415 3.415 0 0 0-.048-.312 6.494 6.494 0 0 0-.098-.468l-.014-.06c-.03-.108-.056-.21-.09-.317a11.824 11.824 0 0 0-.328-.972 5.212 5.212 0 0 0-.142-.355c-.072-.178-.146-.339-.213-.49a3.564 3.564 0 0 1-.094-.197 4.658 4.658 0 0 0-.103-.213c-.024-.053-.053-.104-.072-.152l-.211-.388c-.029-.053.019-.118.077-.101l1.32.357h.01l.173.05.192.054.07.019v-.783c0-.379.302-.686.679-.686a.66.66 0 0 1 .477.202.69.69 0 0 1 .2.484V6.65l.141.039c.01.005.022.01.031.017.034.024.084.062.147.11.05.038.103.086.165.137a10.351 10.351 0 0 1 .574.504c.214.199.454.432.684.691.065.074.127.146.192.226.062.079.132.156.19.232.079.104.16.212.235.324.033.053.074.108.105.161.096.142.178.288.257.435.034.067.067.141.096.213.089.197.159.396.202.598a.65.65 0 0 1 .029.132v.01c.014.057.019.12.024.184a2.057 2.057 0 0 1-.106.874c-.031.084-.06.17-.098.254-.075.17-.161.343-.264.502-.034.06-.075.122-.113.182-.043.063-.089.123-.127.18a3.89 3.89 0 0 1-.173.221c-.053.072-.106.144-.166.209-.081.098-.16.19-.245.278-.048.058-.1.118-.156.17-.052.06-.108.113-.156.161-.084.084-.15.147-.208.202l-.137.122a.102.102 0 0 1-.072.03h-1.051v1.346h1.322c.295 0 .576-.104.804-.298.077-.067.415-.36.816-.802a.094.094 0 0 1 .05-.03l3.65-1.057a.108.108 0 0 1 .138.103z" />
		</svg>
	),
	magicEden: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 541 541"
			className="opacity-50 dark:opacity-[0.65] dark:invert"
			height="100%"
			width="100%">
			<image
				id="image0"
				width="541"
				height="541"
				x="0"
				y="0"
				href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAh0AAAIdCAMAAACuvj/VAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAUVBMVEX///9cWGAvKzUSDBgh GyZNSVIwKjU+OkROSlMxKzY/OUQTDRgTDRkiHCc+OUNAOkQvKjVdWWEhHCdAOkVOSVNNSFI/O0U+ OkM/OkVcV2D////wgPaLAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAALEsAACxL AaU9lqkAAAAHdElNRQfmBwgHOx64r2IeAAANmUlEQVR42u3dC2LbRhKEYSuS5cTx2spD2fX9L7qh ZEukngRQNdU9+L8DSD3dRWKGBMkPHwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAC1z88svlv65++XiRLsW1wo9NZdv28eryqev0KN0L7OYqk5GPrxaUnql9gd18Gt26 tx9UEzyD9H/WOFGrdc3zMVk2RubjvNY1zseE2Rg1kPMvx+kh2xfYza/23i15XLV8+rhOz9DoN3Pv FpaTHrV9gd3U6l162PYFduNr3edS1TikZzeAq3VrwtErHunJDeFp3cXKavq8/ZKe2xi/1+rd8Bdy V5rzZY7nvlQKR5d4zHyUPaU/2G56YLWIR3pmA6lbt/GB1SAe6YmNpL62bK2nfDz2c1050F5btm/Y isdj3jdXXiZtnqCe2vFIT2u0/1TrXeV4pIc1nPJFD01FdeOxr03HHd27+aqKyr6jnx5VgO7YIiup aDzSk4pQNU/4vFsyHuk5Zaj2pcqaCsZjh5uOA9WlRVpUvXikxxQiOrV81VZVLR7pKcXUbF+teOzl bfvnvpVMR6l47HTTcaDZlurrKhSP9IiCJNvStTcMvqVMPNITSpKkw/LuZZF47Pi6IkrHjaW0EvHY 29v2pyTpMNVWIR7p+WRVTkeBeKTHE1Y6HfF47HrTcVk9Hel4pKeTVjwd2XikhxNXPR3JeKRnkyd5 Jd1aYSwee990/OuP8um4vAqlIz2aPM07+OYiM/FIj6YAzd0/7ioT8djv2/aPNB+Hs5c5Ph5sOi6r 3vzz3PB4pAdTgei20gGVDo5HejAliD5nPaLUofHgunJZ9I701wyMx77ftv9J9RUNY6odF4/0XEqQ fU5yVMGEYyDZt7sMq3hIONh0HBT8iPW7RqQjPZcaWvaTcIwh/NawkWUTjhGU3zg4tHBvONh03On7 eLOmIz2WGjq3lHCY9e6pLRy8bX/Q/RFnCgebjgN1V/uvILWOev6coauEw+OvOdqqXwXXlYkedOpF 8Lb95d+OcISekqdYRCG3lmzEGjvDGqow3jyTWpJwCbvedFy5njayj7sJlhB29dUZjHBr+6/gJemv LdEKNrL9Al6g/7XPqGQrFfUX23RIPvleR7SX3eu3rKiS5s1Mp+Ep5c/1FRDu5sbqi11XLmfbeKS7 uan4euFQ/l5fAelmbopHunb5gqpJ93JLN9OVyxdUTrqVG7pZ8bpyoPzIAOlYGY+6b9vPc3BJd/JO 38pfNs3BJd3Ie20Lf8U/6bFOlY7l8ai66Vi7nprSbVzbznS96vXUlO7iynamq32X6NeCSccPPat+ 1RTn2nQTj5xfdPFNx70ZzrXpHh676Fj06yY416ZbeOJTw5rf0P9cm+7gqbPi0eK6cic93MnScU48 +oSjfzzS/Xvq/XikK1yi+8El3b9n3otHur5lmscj3b7n3o6H/rpybe1C73OtccxrvRUP/dv2v5nb 0Ppca5zyap8GlvvF3ofON5oah7zep2HVPrwdcuFbTXrEs6XjtU+j6jcdj3/7v77VpGc8WzpeiYf8 3xxvCnyvo/Q9uDhHvMX1iFpPx+b7xtO2BxfnhDd5Hg/99Ib1ouvBxTjfjZ7Gw7npIB7d0vE0HiMm 5ltMz3OtcbqbXVsLfWmvaPyMTHrQ06XjOB4Driuef/NTyxtNncPd7iEeg8LBubZTOh7iIf/Dr24T Odf2ScePeMj/7JdER/odXIyD1TjEw/5KB/Fomg6LP0I96XYfcnpOEe88hjnX7jkd754ejDc2p+dN OrZPyHdw6fWyR3pSAed8H7Hvv7d62SM9qvHOOzik/38N6VkNd+5j11dBo3ikhzVcgc70OdemhzXa +b+ux42mu0vHkmd1zrU7S8eyA4PvXNvl4JKe11hlmtNkZ5qe11CLf9LXV0qPH4HSrbd+1lY8YG21 9Li2yJZr7mZqILZqWlxbZKt1d1NW4TK+c2168ol0GDf6G/21rkG2c22HGwlli334i0XjsfqZ3Lae 9Ogj6agZjw27QFdJDZ48ZGs9+psV41GiR8Ka+qajYDxWbjq88fiWHn4mHeXisfH4aLrRtP5rHrKl nv7ZWvHYPAbTwSU9/FQ6asVje5s88Si/L7VNoFA8FC9LWpZT/tIiW+mYfq6hec3aUlp6+rl0VImH 6gHqqK36d77IFvrC367xawj1WvWo+sbDOoQK8dC9F2o411bfeMgW+uJfz8dD+Ua5fjX7Tkc+HtJm DfsGoirc6wzHQ9wt+UY7Pf5wOrLxuF7SiqHt+mHxna6TpSMZD3k45DvT4vcPytb5+r/IxaNyv+6R jlg8DO3iuUM/ikw89NcV/b6j+MthsnW++V8S8biq3K2feO44CMTD0Cz9KnZ/ZnE1dls92WY9KP6B yWHTGByPDpuOM7oWNm6dQ+Ph2HQYFrDz91nM3d1QzWKO8kmHt7/DwmG5+6f6ZxaGDmRUPJpsOspv O8amY1A8mmw66l9YBqdjTDwMbfJ83qn4a2HD0zEiHqXbdKz8U8fwdPjj0WbTUf1NFuW6z/6P5ni0 2XTU35Mm0mGOh6FHF55K619YEulwfsd0n01Hh6eOSDqM8eiz6ah/YFEufdF/dcWj0aajwXUllQ5X PAwNMm06Lv+Xnvw5UoOxxKN0g061eOqIpcMRj0abjg5bUuXqF/9neTwabTqq3zH4Uy4d8ngYuuPa dHQ4rxwkZ6ONR+nunOqx6VCuf80/V8aDTUflBqz677p4dNp0FL8R/Ug2HboLu6E1e990fIinQ1VA 6da0DUc+HZIKGm062uxIpT1IluAIh2vTEZt0ZjTbV12x465NR2rOockoll2w46Zw9DmuaLuQq+Jz 5bac6rQjlbYhVkajTUe3cFRJx4Y6DE3Z742ksqmIh1QoHKbryu/jp1umEaFKbiv3RNyh8Qqtfc1/ bbTpGD5agUqLL9JyTzi2/aplSKV0LC+mdEdOtDuuaHuRqKZ0Q07U/8istxmBchwvg3k2Hf3OsveK pWPJb1w4wmF66hg40JrdUBV09oO3djumCEe9dJxbkqUbnp/BbPbW25GC6TinKMeLYK5NR8/jyp2S 6fjw/e3/5XgNTNqMScJRNB0f3noce543lL041vQsK+6IobaXAnLja8U+f+r+TZXTcXB78xiM79ZO eDYd1pLtaIO8ExN1hT6oG3Gs71lW3JT0QjayXFc6H1fukI47nwnHS0iHtg1HWp9lxW1JL6RGF440 vI3U15f0QrawbDrSi1KgGcomTNIPfWPSC6nQgyMtbyP1dSa9kAItOOJ6n7Bra9ILWc2x6eh/lr1H Ogzh6P3Wm6M36YXEG/BohrOsuDnphazkuK6k16Sz85Y4fisyvSahnffEEI45zrLi9qQXkl39o1mO K9r+pBeyhmHTMVU49p0OfTimOcuKG5ReSHLtj5r87srwDqUXspzjMNv9VsEndpwOQzhmuOPH0qL0 QnIrP8GudIp0eD5QPdKnj/YmyWpNT3sh15fkj+a9VUBWZnrcqXXnGQMiqzE97tCyayjfpvS8F5nl uuJuf/HyTNKzNHD8bOI+05GepIfhMC2rLT3xBea7rtzTP33ISkuPPLHmcsp2Kj1ywnEgfp9HVld6 5meb9bpy7x/SUWPFNUnjIasqPXTCYRhEyaKM5r6uqCdRsSan9OgGEN69KKspPfbz7OCpQ3kLkqyk 9NwHL7e0eu1Kz51wPJJdW2QVpQdPOo78Wq1f6cETjiOqJw9ZQenJk45joicPWT3pyZ9hFweWe6In D1k96dGPXGt9oi+YkdWTHv37HN/VUZbm0iIrJz37gUvtQHNpkZWTnj3pOEE6lvmaHthQmo2HrJz0 8MettIdaPUsPn3ScktxDKKsmPfz3XKTHNZjke2Zk1aSn/559bTtIxzL9v5FhmVLpsHxQTyk9rdFK pcP28+OkY51S6UgPn3Q8QTpIh3kgN9vr0BVDOnQkTRMd9MpvSveWjlJv4V+kh/8u1ZNkE6Vu/0nP /n27uruDdGQW2sW3Qk0r/2rH7tIhaprkepyePOl4otLnnVr8Nu+uNh6yb5gT1JIe/LCFtiFr2vY3 L1s8dewqHZW+pCE99jPt6P4f4U9MbS2lyVPHjp48pL9Ot7GW9NDPtpt9qfTX6baVkp75sIW2If5h yy2ltLmu7Cce4qZtObakB77ILj6FL/82/fWlpOc9bKFtGH4weW0pn9PjJh5PGZq28im31abjXnp4 bpamrdp6NAzH7PGo07SW4Zg7HtJXOjY1rWk4Zo6HsWkLLy4d7vh5xawH2zpNS094m/QcHf409+z8 eNT/hIJsqV3YthyPzqyk8VXlwVz5GPNwPadnbbejT9ymR9osGwfv5aP9ReXYFN/5MnYi12UqGeF7 70vM1fir/GvPuTPsN170/bbldwN9jfXrabuuvqdHiGJub29ubr5O+5QBAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJjc/wGpVr8ZJheXcAAAACV0RVh0ZGF0ZTpjcmVh dGUAMjAyMi0wNy0wOFQwNTo1OTozMCswMjowMK8KQIUAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjIt MDctMDhUMDU6NTk6MzArMDI6MDDeV/g5AAAAAElFTkSuQmCC"
			/>
		</svg>
	),
	wallet1: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			height="100%"
			width="100%">
			<path fill="none" d="M0 0h24v24H0z" />
			<path
				d="M18 7h3a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h15v4zM4 9v10h16V9H4zm0-4v2h12V5H4zm11 8h3v2h-3v-2z"
				fill="currentColor"
			/>
		</svg>
	),
	wallet2: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			height="100%"
			width="100%">
			<path fill="none" d="M0 0h24v24H0z" />
			<path
				d="M20 7V5H4v14h16v-2h-8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h8zM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm10 6v6h7V9h-7zm2 2h3v2h-3v-2z"
				fill="currentColor"
			/>
		</svg>
	),
	wallet3: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			height="100%"
			width="100%">
			<path fill="none" d="M0 0h24v24H0z" />
			<path
				d="M22 7h1v10h-1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3zm-2 10h-6a5 5 0 0 1 0-10h6V5H4v14h16v-2zm1-2V9h-7a3 3 0 0 0 0 6h7zm-7-4h3v2h-3v-2z"
				fill="currentColor"
			/>
		</svg>
	),
	fingerprint: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			strokeWidth={2}
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"
			/>
		</svg>
	),
	rainbow: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			height="100%"
			width="100%">
			<path fill="none" d="M0 0h24v24H0z" />
			<path
				d="M12 4c6.075 0 11 4.925 11 11v5h-2v-5a9 9 0 0 0-8.735-8.996L12 6a9 9 0 0 0-8.996 8.735L3 15v5H1v-5C1 8.925 5.925 4 12 4zm0 4a7 7 0 0 1 7 7v5h-2v-5a5 5 0 0 0-4.783-4.995L12 10a5 5 0 0 0-4.995 4.783L7 15v5H5v-5a7 7 0 0 1 7-7zm0 4a3 3 0 0 1 3 3v5h-2v-5a1 1 0 0 0-.883-.993L12 14a1 1 0 0 0-.993.883L11 15v5H9v-5a3 3 0 0 1 3-3z"
				fill="currentColor"
			/>
		</svg>
	),
	collection: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			strokeWidth={2}
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
			/>
		</svg>
	),
	bookOpen: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={2}
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
			/>
		</svg>
	),
	houseModern: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={2}
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205l3 1m1.5.5l-1.5-.5M6.75 7.364V3h-3v18m3-13.636l10.5-3.819"
			/>
		</svg>
	),
	cube: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={2}
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
			/>
		</svg>
	),
	bookmarkSquare: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={2}
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M16.5 3.75V16.5L12 14.25 7.5 16.5V3.75m9 0H18A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h1.5m9 0h-9"
			/>
		</svg>
	),
	bookmark: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={2}
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z"
			/>
		</svg>
	),
	openai: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			height="100%"
			width="100%">
			<path
				d="M20.5624 10.1875C20.8124 9.5 20.8749 8.8125 20.8124 8.125C20.7499 7.4375 20.4999 6.75 20.1874 6.125C19.6249 5.1875 18.8124 4.4375 17.8749 4C16.8749 3.5625 15.8124 3.4375 14.7499 3.6875C14.2499 3.1875 13.6874 2.75 13.0624 2.4375C12.4374 2.125 11.6874 2 10.9999 2C9.9374 2 8.8749 2.3125 7.9999 2.9375C7.1249 3.5625 6.4999 4.4375 6.1874 5.4375C5.4374 5.625 4.8124 5.9375 4.1874 6.3125C3.6249 6.75 3.1874 7.3125 2.8124 7.875C2.24991 8.8125 2.06241 9.875 2.18741 10.9375C2.31241 12 2.7499 13 3.4374 13.8125C3.1874 14.5 3.1249 15.1875 3.1874 15.875C3.2499 16.5625 3.4999 17.25 3.8124 17.875C4.3749 18.8125 5.1874 19.5625 6.1249 20C7.1249 20.4375 8.1874 20.5625 9.2499 20.3125C9.7499 20.8125 10.3124 21.25 10.9374 21.5625C11.5624 21.875 12.3124 22 12.9999 22C14.0624 22 15.1249 21.6875 15.9999 21.0625C16.8749 20.4375 17.4999 19.5625 17.8124 18.5625C18.4999 18.4375 19.1874 18.125 19.7499 17.6875C20.3124 17.25 20.8124 16.75 21.1249 16.125C21.6874 15.1875 21.8749 14.125 21.7499 13.0625C21.6249 12 21.2499 11 20.5624 10.1875ZM13.0624 20.6875C12.0624 20.6875 11.3124 20.375 10.6249 19.8125C10.6249 19.8125 10.6874 19.75 10.7499 19.75L14.7499 17.4375C14.8749 17.375 14.9374 17.3125 14.9999 17.1875C15.0624 17.0625 15.0624 17 15.0624 16.875V11.25L16.7499 12.25V16.875C16.8124 19.0625 15.0624 20.6875 13.0624 20.6875ZM4.9999 17.25C4.5624 16.5 4.3749 15.625 4.5624 14.75C4.5624 14.75 4.6249 14.8125 4.6874 14.8125L8.6874 17.125C8.8124 17.1875 8.8749 17.1875 8.9999 17.1875C9.1249 17.1875 9.2499 17.1875 9.3124 17.125L14.1874 14.3125V16.25L10.1249 18.625C9.2499 19.125 8.2499 19.25 7.3124 19C6.3124 18.75 5.4999 18.125 4.9999 17.25ZM3.9374 8.5625C4.3749 7.8125 5.0624 7.25 5.8749 6.9375V7.0625V11.6875C5.8749 11.8125 5.8749 11.9375 5.9374 12C5.9999 12.125 6.0624 12.1875 6.1874 12.25L11.0624 15.0625L9.3749 16.0625L5.3749 13.75C4.4999 13.25 3.8749 12.4375 3.6249 11.5C3.3749 10.5625 3.4374 9.4375 3.9374 8.5625ZM17.7499 11.75L12.8749 8.9375L14.5624 7.9375L18.5624 10.25C19.1874 10.625 19.6874 11.125 19.9999 11.75C20.3124 12.375 20.4999 13.0625 20.4374 13.8125C20.3749 14.5 20.1249 15.1875 19.6874 15.75C19.2499 16.3125 18.6874 16.75 17.9999 17V12.25C17.9999 12.125 17.9999 12 17.9374 11.9375C17.9374 11.9375 17.8749 11.8125 17.7499 11.75ZM19.4374 9.25C19.4374 9.25 19.3749 9.1875 19.3124 9.1875L15.3124 6.875C15.1874 6.8125 15.1249 6.8125 14.9999 6.8125C14.8749 6.8125 14.7499 6.8125 14.6874 6.875L9.8124 9.6875V7.75L13.8749 5.375C14.4999 5 15.1874 4.875 15.9374 4.875C16.6249 4.875 17.3124 5.125 17.9374 5.5625C18.4999 6 18.9999 6.5625 19.2499 7.1875C19.4999 7.8125 19.5624 8.5625 19.4374 9.25ZM8.9374 12.75L7.2499 11.75V7.0625C7.2499 6.375 7.4374 5.625 7.8124 5.0625C8.1874 4.4375 8.7499 4 9.3749 3.6875C9.9999 3.375 10.7499 3.25 11.4374 3.375C12.1249 3.4375 12.8124 3.75 13.3749 4.1875C13.3749 4.1875 13.3124 4.25 13.2499 4.25L9.2499 6.5625C9.1249 6.625 9.0624 6.6875 8.9999 6.8125C8.9374 6.9375 8.9374 7 8.9374 7.125V12.75ZM9.8124 10.75L11.9999 9.5L14.1874 10.75V13.25L11.9999 14.5L9.8124 13.25V10.75Z"
				fill="currentColor"
			/>
		</svg>
	),
	openaiText: (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 1180 320"
			height="100%"
			width="100%">
			<g fill="currentColor" data-v-22ee7e7c="">
				<path d="m367.44 153.84c0 52.32 33.6 88.8 80.16 88.8s80.16-36.48 80.16-88.8-33.6-88.8-80.16-88.8-80.16 36.48-80.16 88.8zm129.6 0c0 37.44-20.4 61.68-49.44 61.68s-49.44-24.24-49.44-61.68 20.4-61.68 49.44-61.68 49.44 24.24 49.44 61.68z" />
				<path d="m614.27 242.64c35.28 0 55.44-29.76 55.44-65.52s-20.16-65.52-55.44-65.52c-16.32 0-28.32 6.48-36.24 15.84v-13.44h-28.8v169.2h28.8v-56.4c7.92 9.36 19.92 15.84 36.24 15.84zm-36.96-69.12c0-23.76 13.44-36.72 31.2-36.72 20.88 0 32.16 16.32 32.16 40.32s-11.28 40.32-32.16 40.32c-17.76 0-31.2-13.2-31.2-36.48z" />
				<path d="m747.65 242.64c25.2 0 45.12-13.2 54-35.28l-24.72-9.36c-3.84 12.96-15.12 20.16-29.28 20.16-18.48 0-31.44-13.2-33.6-34.8h88.32v-9.6c0-34.56-19.44-62.16-55.92-62.16s-60 28.56-60 65.52c0 38.88 25.2 65.52 61.2 65.52zm-1.44-106.8c18.24 0 26.88 12 27.12 25.92h-57.84c4.32-17.04 15.84-25.92 30.72-25.92z" />
				<path d="m823.98 240h28.8v-73.92c0-18 13.2-27.6 26.16-27.6 15.84 0 22.08 11.28 22.08 26.88v74.64h28.8v-83.04c0-27.12-15.84-45.36-42.24-45.36-16.32 0-27.6 7.44-34.8 15.84v-13.44h-28.8z" />
				<path d="m1014.17 67.68-65.28 172.32h30.48l14.64-39.36h74.4l14.88 39.36h30.96l-65.28-172.32zm16.8 34.08 27.36 72h-54.24z" />
				<path d="m1163.69 68.18h-30.72v172.32h30.72z" />
				<path d="m297.06 130.97c7.26-21.79 4.76-45.66-6.85-65.48-17.46-30.4-52.56-46.04-86.84-38.68-15.25-17.18-37.16-26.95-60.13-26.81-35.04-.08-66.13 22.48-76.91 55.82-22.51 4.61-41.94 18.7-53.31 38.67-17.59 30.32-13.58 68.54 9.92 94.54-7.26 21.79-4.76 45.66 6.85 65.48 17.46 30.4 52.56 46.04 86.84 38.68 15.24 17.18 37.16 26.95 60.13 26.8 35.06.09 66.16-22.49 76.94-55.86 22.51-4.61 41.94-18.7 53.31-38.67 17.57-30.32 13.55-68.51-9.94-94.51zm-120.28 168.11c-14.03.02-27.62-4.89-38.39-13.88.49-.26 1.34-.73 1.89-1.07l63.72-36.8c3.26-1.85 5.26-5.32 5.24-9.07v-89.83l26.93 15.55c.29.14.48.42.52.74v74.39c-.04 33.08-26.83 59.9-59.91 59.97zm-128.84-55.03c-7.03-12.14-9.56-26.37-7.15-40.18.47.28 1.3.79 1.89 1.13l63.72 36.8c3.23 1.89 7.23 1.89 10.47 0l77.79-44.92v31.1c.02.32-.13.63-.38.83l-64.41 37.19c-28.69 16.52-65.33 6.7-81.92-21.95zm-16.77-139.09c7-12.16 18.05-21.46 31.21-26.29 0 .55-.03 1.52-.03 2.2v73.61c-.02 3.74 1.98 7.21 5.23 9.06l77.79 44.91-26.93 15.55c-.27.18-.61.21-.91.08l-64.42-37.22c-28.63-16.58-38.45-53.21-21.95-81.89zm221.26 51.49-77.79-44.92 26.93-15.54c.27-.18.61-.21.91-.08l64.42 37.19c28.68 16.57 38.51 53.26 21.94 81.94-7.01 12.14-18.05 21.44-31.2 26.28v-75.81c.03-3.74-1.96-7.2-5.2-9.06zm26.8-40.34c-.47-.29-1.3-.79-1.89-1.13l-63.72-36.8c-3.23-1.89-7.23-1.89-10.47 0l-77.79 44.92v-31.1c-.02-.32.13-.63.38-.83l64.41-37.16c28.69-16.55 65.37-6.7 81.91 22 6.99 12.12 9.52 26.31 7.15 40.1zm-168.51 55.43-26.94-15.55c-.29-.14-.48-.42-.52-.74v-74.39c.02-33.12 26.89-59.96 60.01-59.94 14.01 0 27.57 4.92 38.34 13.88-.49.26-1.33.73-1.89 1.07l-63.72 36.8c-3.26 1.85-5.26 5.31-5.24 9.06l-.04 89.79zm14.63-31.54 34.65-20.01 34.65 20v40.01l-34.65 20-34.65-20z" />
			</g>
		</svg>
	),
	share: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			height="100%"
			width="100%">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15m0-3l-3-3m0 0l-3 3m3-3V15"
			/>
		</svg>
	),
	linkedIn: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor"
			height="100%"
			width="100%">
			<path d="M18.3362 18.339H15.6707V14.1622C15.6707 13.1662 15.6505 11.8845 14.2817 11.8845C12.892 11.8845 12.6797 12.9683 12.6797 14.0887V18.339H10.0142V9.75H12.5747V10.9207H12.6092C12.967 10.2457 13.837 9.53325 15.1367 9.53325C17.8375 9.53325 18.337 11.3108 18.337 13.6245V18.339H18.3362ZM7.00373 8.57475C6.14573 8.57475 5.45648 7.88025 5.45648 7.026C5.45648 6.1725 6.14648 5.47875 7.00373 5.47875C7.85873 5.47875 8.55173 6.1725 8.55173 7.026C8.55173 7.88025 7.85798 8.57475 7.00373 8.57475ZM8.34023 18.339H5.66723V9.75H8.34023V18.339ZM19.6697 3H4.32923C3.59498 3 3.00098 3.5805 3.00098 4.29675V19.7033C3.00098 20.4202 3.59498 21 4.32923 21H19.6675C20.401 21 21.001 20.4202 21.001 19.7033V4.29675C21.001 3.5805 20.401 3 19.6675 3H19.6697Z" />
		</svg>
	),
	graduationCapOutline: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M4 11.3333L0 9L12 2L24 9V17.5H22V10.1667L20 11.3333V18.0113L19.7774 18.2864C17.9457 20.5499 15.1418 22 12 22C8.85817 22 6.05429 20.5499 4.22263 18.2864L4 18.0113V11.3333ZM6 12.5V17.2917C7.46721 18.954 9.61112 20 12 20C14.3889 20 16.5328 18.954 18 17.2917V12.5L12 16L6 12.5ZM3.96927 9L12 13.6846L20.0307 9L12 4.31541L3.96927 9Z" />
		</svg>
	),
	graduationCap: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M12 2 0 9 12 16 22 10.1667V17.5H24V9L12 2ZM3.99902 13.4905V18.0001C5.82344 20.429 8.72812 22.0001 11.9998 22.0001 15.2714 22.0001 18.1761 20.429 20.0005 18.0001L20.0001 13.4913 12.0003 18.1579 3.99902 13.4905Z" />
		</svg>
	),
	paper: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M20 2C21.6569 2 23 3.34315 23 5V7H21V19C21 20.6569 19.6569 22 18 22H4C2.34315 22 1 20.6569 1 19V17H17V19C17 19.5128 17.386 19.9355 17.8834 19.9933L18 20C18.5128 20 18.9355 19.614 18.9933 19.1166L19 19V4H6C5.48716 4 5.06449 4.38604 5.00673 4.88338L5 5V15H3V5C3 3.34315 4.34315 2 6 2H20Z" />
		</svg>
	),
	suitcase: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M15 3C15.5523 3 16 3.44772 16 4V6H21C21.5523 6 22 6.44772 22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7C2 6.44772 2.44772 6 3 6H8V4C8 3.44772 8.44772 3 9 3H15ZM16 8H8V19H16V8ZM4 8V19H6V8H4ZM14 5H10V6H14V5ZM18 8V19H20V8H18Z" />
		</svg>
	),
	paperList: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M19 22H5C3.34315 22 2 20.6569 2 19V3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V15H22V19C22 20.6569 20.6569 22 19 22ZM18 17V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V17H18ZM16 20V4H4V19C4 19.5523 4.44772 20 5 20H16ZM6 7H14V9H6V7ZM6 11H14V13H6V11ZM6 15H11V17H6V15Z" />
		</svg>
	),
	code: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M24 12L18.3431 17.6569L16.9289 16.2426L21.1716 12L16.9289 7.75736L18.3431 6.34315L24 12ZM2.82843 12L7.07107 16.2426L5.65685 17.6569L0 12L5.65685 6.34315L7.07107 7.75736L2.82843 12ZM9.78845 21H7.66009L14.2116 3H16.3399L9.78845 21Z" />
		</svg>
	),
	article: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM7 6H11V10H7V6ZM7 12H17V14H7V12ZM7 16H17V18H7V16ZM13 7H17V9H13V7Z" />
		</svg>
	),
	newspaper: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M16 20V4H4V19C4 19.5523 4.44772 20 5 20H16ZM19 22H5C3.34315 22 2 20.6569 2 19V3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V10H22V19C22 20.6569 20.6569 22 19 22ZM18 12V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V12H18ZM6 6H12V12H6V6ZM8 8V10H10V8H8ZM6 13H14V15H6V13ZM6 16H14V18H6V16Z" />
		</svg>
	),
	focus: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z" />
		</svg>
	),
	externalLink: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V11H19L18.9999 6.413L11.2071 14.2071L9.79289 12.7929L17.5849 5H13V3H21Z" />
		</svg>
	),
	calendarSchedule: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M7 3V1H9V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V9H20V5H17V7H15V5H9V7H7V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7ZM17 12C14.7909 12 13 13.7909 13 16C13 18.2091 14.7909 20 17 20C19.2091 20 21 18.2091 21 16C21 13.7909 19.2091 12 17 12ZM11 16C11 12.6863 13.6863 10 17 10C20.3137 10 23 12.6863 23 16C23 19.3137 20.3137 22 17 22C13.6863 22 11 19.3137 11 16ZM16 13V16.4142L18.2929 18.7071L19.7071 17.2929L18 15.5858V13H16Z" />
		</svg>
	),
	microscope: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M13.1962 2.26797L16.4462 7.89714C16.7223 8.37543 16.5584 8.98702 16.0801 9.26316L14.7806 10.0123L15.7811 11.7452L14.049 12.7452L13.0485 11.0123L11.75 11.7632C11.2717 12.0393 10.6601 11.8754 10.384 11.3971L8.5462 8.21466C6.49383 8.83736 5 10.7442 5 13C5 13.6254 5.1148 14.2239 5.32447 14.7757C6.0992 14.284 7.01643 14 8 14C9.68408 14 11.1737 14.8326 12.0797 16.1086L19.7681 11.6704L20.7681 13.4025L12.8898 17.951C12.962 18.2893 13 18.6402 13 19C13 19.3427 12.9655 19.6774 12.8999 20.0007L21 20V22L4.00054 22.0012C3.3723 21.1654 3 20.1262 3 19C3 17.9928 3.29782 17.0551 3.81021 16.2703C3.29276 15.2948 3 14.1816 3 13C3 10.0047 4.88131 7.44881 7.52677 6.44948L7.13397 5.76797C6.58169 4.81139 6.90944 3.58821 7.86603 3.03592L10.4641 1.53592C11.4207 0.983638 12.6439 1.31139 13.1962 2.26797ZM8 16C6.34315 16 5 17.3432 5 19C5 19.3506 5.06014 19.6872 5.17067 19.9999H10.8293C10.9399 19.6872 11 19.3506 11 19C11 17.3432 9.65685 16 8 16ZM11.4641 3.26797L8.86602 4.76797L11.616 9.53111L14.2141 8.03111L11.4641 3.26797Z" />
		</svg>
	),
	top: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M6 7 18 7V9L6 9 6 7ZM12 11 6 17H18L12 11Z" />
		</svg>
	),
	edit: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M5 18.89H6.41421L15.7279 9.57627L14.3137 8.16206L5 17.4758V18.89ZM21 20.89H3V16.6473L16.435 3.21231C16.8256 2.82179 17.4587 2.82179 17.8492 3.21231L20.6777 6.04074C21.0682 6.43126 21.0682 7.06443 20.6777 7.45495L9.24264 18.89H21V20.89ZM15.7279 6.74785L17.1421 8.16206L18.5563 6.74785L17.1421 5.33363L15.7279 6.74785Z" />
		</svg>
	),
	accountCircle: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12.1597 16C10.1243 16 8.29182 16.8687 7.01276 18.2556C8.38039 19.3474 10.114 20 12 20C13.9695 20 15.7727 19.2883 17.1666 18.1081C15.8956 16.8074 14.1219 16 12.1597 16ZM12 4C7.58172 4 4 7.58172 4 12C4 13.8106 4.6015 15.4807 5.61557 16.8214C7.25639 15.0841 9.58144 14 12.1597 14C14.6441 14 16.8933 15.0066 18.5218 16.6342C19.4526 15.3267 20 13.7273 20 12C20 7.58172 16.4183 4 12 4ZM12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5ZM12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7Z" />
		</svg>
	),
	profile: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M21.0082 3C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082ZM20 5H4V19H20V5ZM18 15V17H6V15H18ZM12 7V13H6V7H12ZM18 11V13H14V11H18ZM10 9H8V11H10V9ZM18 7V9H14V7H18Z" />
		</svg>
	),
	googleScholar: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 512 512"
			fill="currentColor"
			className="mt-[1.5px] h-[15px] w-[15px]">
			<path d="M390.9 298.5c0 0 0 .1 .1 .1c9.2 19.4 14.4 41.1 14.4 64C405.3 445.1 338.5 512 256 512s-149.3-66.9-149.3-149.3c0-22.9 5.2-44.6 14.4-64h0c1.7-3.6 3.6-7.2 5.6-10.7c4.4-7.6 9.4-14.7 15-21.3c27.4-32.6 68.5-53.3 114.4-53.3c33.6 0 64.6 11.1 89.6 29.9c9.1 6.9 17.4 14.7 24.8 23.5c5.6 6.6 10.6 13.8 15 21.3c2 3.4 3.8 7 5.5 10.5zm26.4-18.8c-30.1-58.4-91-98.4-161.3-98.4s-131.2 40-161.3 98.4L0 202.7 256 0 512 202.7l-94.7 77.1z" />
		</svg>
	),
	mailFilled: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829Z" />
		</svg>
	),
	service: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M3.16113 4.46875C5.58508 2.0448 9.44716 1.9355 12.0008 4.14085C14.5528 1.9355 18.4149 2.0448 20.8388 4.46875C23.2584 6.88836 23.3716 10.741 21.1785 13.2947L13.4142 21.0858C12.6686 21.8313 11.4809 21.8652 10.6952 21.1874L10.5858 21.0858L2.82141 13.2947C0.628282 10.741 0.741522 6.88836 3.16113 4.46875ZM4.57534 5.88296C2.86819 7.59011 2.81942 10.3276 4.42902 12.0937L4.57534 12.2469L12 19.6715L17.3026 14.3675L13.7677 10.8327L12.7071 11.8934C11.5355 13.0649 9.636 13.0649 8.46443 11.8934C7.29286 10.7218 7.29286 8.8223 8.46443 7.65073L10.5656 5.54823C8.85292 4.17713 6.37076 4.23993 4.7286 5.73663L4.57534 5.88296ZM13.0606 8.71139C13.4511 8.32086 14.0843 8.32086 14.4748 8.71139L18.7168 12.9533L19.4246 12.2469C21.1819 10.4896 21.1819 7.64032 19.4246 5.88296C17.7174 4.17581 14.9799 4.12704 13.2139 5.73663L13.0606 5.88296L9.87864 9.06494C9.51601 9.42757 9.49011 9.99942 9.80094 10.3919L9.87864 10.4792C10.2413 10.8418 10.8131 10.8677 11.2056 10.5569L11.2929 10.4792L13.0606 8.71139Z" />
		</svg>
	),
	personSpeaks: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path d="M16.9337 8.96494C16.426 5.03562 13.0675 2 9 2 4.58172 2 1 5.58172 1 10 1 11.8924 1.65707 13.6313 2.7555 15.0011 3.56351 16.0087 4.00033 17.1252 4.00025 18.3061L4 22H13L13.001 19H15C16.1046 19 17 18.1046 17 17V14.071L18.9593 13.2317C19.3025 13.0847 19.3324 12.7367 19.1842 12.5037L16.9337 8.96494ZM3 10C3 6.68629 5.68629 4 9 4 12.0243 4 14.5665 6.25141 14.9501 9.22118L15.0072 9.66262 16.5497 12.0881 15 12.7519V17H11.0017L11.0007 20H6.00013L6.00025 18.3063C6.00036 16.6672 5.40965 15.114 4.31578 13.7499 3.46818 12.6929 3 11.3849 3 10ZM21.1535 18.1024 19.4893 16.9929C20.4436 15.5642 21 13.8471 21 12.0001 21 10.153 20.4436 8.4359 19.4893 7.00722L21.1535 5.89771C22.32 7.64386 23 9.74254 23 12.0001 23 14.2576 22.32 16.3562 21.1535 18.1024Z" />
		</svg>
	),
	bookShelf: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path fill="none" d="M0 0h24v24H0z"></path>
			<path d="M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H14C14.5523 21 15 20.5523 15 20V15.2973L15.9995 19.9996C16.1143 20.5398 16.6454 20.8847 17.1856 20.7699L21.0982 19.9382C21.6384 19.8234 21.9832 19.2924 21.8684 18.7522L18.9576 5.0581C18.8428 4.51788 18.3118 4.17304 17.7716 4.28786L14.9927 4.87853C14.9328 4.38353 14.5112 4 14 4H10C10 3.44772 9.55228 3 9 3H4ZM10 6H13V14H10V6ZM10 19V16H13V19H10ZM8 5V15H5V5H8ZM8 17V19H5V17H8ZM17.3321 16.6496L19.2884 16.2338L19.7042 18.1898L17.7479 18.6057L17.3321 16.6496ZM16.9163 14.6933L15.253 6.86789L17.2092 6.45207L18.8726 14.2775L16.9163 14.6933Z"></path>
		</svg>
	),
	addCircle: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path fill="none" d="M0 0h24v24H0z"></path>
			<path d="M11 11V7H13V11H17V13H13V17H11V13H7V11H11ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"></path>
		</svg>
	),
	links: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path fill="none" d="M0 0h24v24H0z"></path>
			<path d="M13.0607 8.11097L14.4749 9.52518C17.2086 12.2589 17.2086 16.691 14.4749 19.4247L14.1214 19.7782C11.3877 22.5119 6.95555 22.5119 4.22188 19.7782C1.48821 17.0446 1.48821 12.6124 4.22188 9.87874L5.6361 11.293C3.68348 13.2456 3.68348 16.4114 5.6361 18.364C7.58872 20.3166 10.7545 20.3166 12.7072 18.364L13.0607 18.0105C15.0133 16.0578 15.0133 12.892 13.0607 10.9394L11.6465 9.52518L13.0607 8.11097ZM19.7782 14.1214L18.364 12.7072C20.3166 10.7545 20.3166 7.58872 18.364 5.6361C16.4114 3.68348 13.2456 3.68348 11.293 5.6361L10.9394 5.98965C8.98678 7.94227 8.98678 11.1081 10.9394 13.0607L12.3536 14.4749L10.9394 15.8891L9.52518 14.4749C6.79151 11.7413 6.79151 7.30911 9.52518 4.57544L9.87874 4.22188C12.6124 1.48821 17.0446 1.48821 19.7782 4.22188C22.5119 6.95555 22.5119 11.3877 19.7782 14.1214Z"></path>
		</svg>
	),
	pencilTool: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path fill="none" d="M0 0h24v24H0z"></path>
			<path d="M5 8V20H9V8H5ZM3 7L7 2L11 7V22H3V7ZM19 16V14H16V12H19V10H17V8H19V6H15V20H19V18H17V16H19ZM14 4H20C20.5523 4 21 4.44772 21 5V21C21 21.5523 20.5523 22 20 22H14C13.4477 22 13 21.5523 13 21V5C13 4.44772 13.4477 4 14 4Z"></path>
		</svg>
	),
	uwCSWebring: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="50 100 900 800"
			width={16}
			height={16}
			fill="currentColor">
			<title>UW CS Webring</title>
			<g transform="translate(50,0)">
				<path d="M706.545776,474.512146 C697.271851,456.153046 679.255127,447.254517 659.422485,451.176361 C652.604431,452.524597 645.883850,454.365356 637.789856,456.298523 C641.201233,444.064941 641.181213,431.794891 649.443542,422.137360 C653.072266,417.896027 658.048767,416.085724 663.302063,414.716217 C674.189880,411.877838 685.447144,412.292664 696.476074,410.737701 C697.439880,410.601807 698.513123,410.757782 699.347839,409.603760 C699.859070,407.206757 698.052856,405.462006 696.964722,403.496765 C685.650391,383.061768 675.377136,362.194489 668.688293,339.682648 C658.274109,304.633270 664.088135,271.235382 678.225281,238.529724 C692.416870,205.697998 712.679810,177.359528 740.404602,154.624161 C761.864868,137.025940 786.853821,128.540665 814.371643,126.638893 C842.334167,124.706390 868.445312,132.059082 894.256836,141.563751 C923.327454,152.268478 952.618713,162.320755 983.367798,167.195023 C990.596069,168.340836 997.901917,169.005829 1005.250793,168.947403 C1007.191589,168.931961 1009.235474,168.560318 1010.891296,169.629425 C1011.746094,171.418961 1010.570374,172.385696 1009.844543,173.411728 C988.550842,203.514084 959.410706,221.723434 923.697815,229.610779 C911.880981,232.220581 899.825562,230.863800 887.882202,229.823364 C879.273560,229.073425 870.683044,228.116577 862.075134,227.356995 C860.491150,227.217239 858.734741,226.823059 856.671692,228.665924 C863.411072,243.026855 871.823364,257.011261 875.734314,273.590210 C871.594604,272.305176 869.129272,269.795502 866.334778,267.899170 C848.164551,255.568756 829.194763,244.601074 807.509094,240.106216 C773.069702,232.967834 746.957642,240.664169 725.996826,271.018494 C714.608215,287.510773 705.244507,305.241425 700.930725,325.082245 C697.500061,340.860809 700.689331,355.999969 705.891846,370.648407 C707.378540,370.808929 707.777344,370.234314 708.028442,369.635254 C713.974976,355.448944 724.253601,344.600616 735.121521,334.155792 C741.846191,327.692871 748.392883,321.039062 754.864929,314.322083 C757.121216,311.980408 758.812256,311.666931 760.854004,314.410522 C762.343018,316.411469 763.965515,318.333466 765.691589,320.134308 C779.026001,334.046509 777.231323,348.105377 766.308044,362.329132 C762.057617,367.863678 757.404236,373.151306 752.456360,378.070648 C747.147339,383.349213 746.369995,389.198151 747.670166,396.231842 C750.052490,409.119659 753.272339,421.939423 752.364136,435.252319 C752.019775,440.300903 750.592224,445.097443 749.111877,449.833374 C742.255249,471.769470 737.735291,494.327789 731.248352,516.354004 C725.032043,537.461426 716.380371,557.205261 701.149963,573.768677 C687.108887,589.038696 669.520325,595.899170 649.592468,598.230713 C644.968140,598.771667 640.295715,599.276367 635.656006,599.194763 C631.709106,599.125427 629.654236,600.424438 628.407166,604.269958 C625.327148,613.767090 622.092651,623.233093 616.954163,631.898804 C604.462891,652.964844 586.226379,663.578247 561.516357,662.476379 C552.375183,662.068848 543.234314,661.652832 534.091553,661.284424 C532.461670,661.218750 530.761169,660.824097 528.987549,661.946289 C528.738037,666.234985 531.156555,669.772217 533.008911,673.360229 C541.814026,690.416016 555.260193,703.577759 569.443970,716.066040 C576.158508,721.977905 583.017395,727.725891 589.712891,733.464111 C588.725098,736.015747 586.711853,736.254883 585.164062,737.031006 C561.634949,748.829285 537.880249,760.222473 515.621826,774.365173 C495.870728,786.914734 476.810181,800.488281 462.621521,819.441101 C452.948975,832.361511 444.421204,846.135742 435.289581,859.465210 C428.810303,868.923096 428.711121,868.901550 421.411682,860.083923 C417.271973,855.083191 413.017700,850.204895 407.829987,845.515991 C402.925476,848.941711 399.693665,853.857117 395.980896,858.175415 C387.404755,868.149902 379.243408,878.461609 369.840515,887.729370 C366.944580,890.583679 364.508911,891.314453 361.131622,889.344299 C360.989532,889.261353 360.813324,889.237976 360.668091,889.159119 C353.055847,885.026306 345.679626,883.900818 338.827026,890.723022 C338.146698,891.400391 337.132141,891.772583 336.223999,892.177063 C335.803925,892.364197 335.266693,892.288269 334.301208,892.374695 C331.994171,884.437195 329.219269,876.425049 329.643616,868.164917 C330.009338,861.045166 335.284363,855.539978 338.950287,849.628967 C341.287903,845.859802 343.970978,842.304871 346.939636,838.017761 C338.632782,838.145813 331.564301,839.956665 324.581970,841.868591 C320.058258,843.107178 317.217804,842.242249 315.655731,837.694275 C315.174408,836.292725 314.279114,835.035706 313.597168,833.700439 C306.686188,820.169373 310.937927,806.317017 324.218964,798.779968 C331.631622,794.573303 340.119598,792.702881 347.316589,788.084900 C349.853607,786.456970 354.484192,785.253235 353.296082,781.797241 C352.097137,778.309814 348.081879,781.250061 345.299927,781.207703 C342.547211,781.165833 339.902435,783.246765 336.468170,781.344910 C338.724976,769.214539 341.585876,757.294556 352.776978,749.798889 C359.121521,745.549438 366.149323,744.834717 373.071686,748.946350 C381.374939,753.878052 389.666321,758.831299 397.905701,763.868652 C410.686615,771.682739 423.873596,773.684570 438.506866,768.992859 C458.527496,762.573730 477.579285,754.701416 493.505280,740.508179 C496.400024,737.928406 498.790497,734.952271 501.202850,732.003418 C504.154297,728.395691 501.487732,720.704163 496.773956,718.746094 C485.507721,714.066223 473.525665,711.734497 461.898193,708.238525 C452.803040,705.503906 443.727203,702.750916 435.102753,698.720703 C421.950867,692.574585 411.204102,683.325623 403.046936,671.531494 C388.443237,650.416748 390.565826,619.356384 407.550568,598.906067 C424.140076,578.931641 445.918335,572.329224 471.030670,575.248535 C478.609314,576.129700 486.073181,577.976685 493.606201,579.285950 C495.615875,579.635193 498.096619,580.971191 499.484985,578.485352 C500.636475,576.423584 498.892822,574.721558 497.696503,573.147278 C491.114746,564.485901 482.621246,558.156555 473.089966,553.119995 C461.709259,547.106140 449.515778,543.069275 437.544495,538.478271 C423.350067,533.034607 409.486908,526.954163 398.202972,516.293030 C386.612030,505.341797 387.209686,492.671234 399.973358,482.845947 C413.013947,472.807556 428.370758,469.366638 444.279175,467.713135 C461.163147,465.958252 478.188416,466.187103 495.057312,464.048340 C509.791077,462.180267 523.425537,457.008087 536.832520,450.996033 C538.934387,450.053497 540.899963,448.666656 544.050842,448.731506 C546.473267,455.517212 548.947937,462.520325 551.471558,469.505798 C560.814331,495.367126 572.385925,520.021362 591.017029,540.692627 C600.110046,550.781372 610.498718,559.425415 622.643250,565.628052 C644.121948,576.597961 659.588745,574.631836 677.654358,558.612183 C695.056519,543.180969 704.732727,523.481689 708.685425,500.773163 C710.218079,491.967926 710.795349,483.234833 706.545776,474.512146  z" />
				<path d="M525.723511,423.724731 C521.983948,424.025787 522.279785,426.766022 522.228577,428.961548 C522.104309,434.290649 522.302673,439.626556 522.259705,444.958771 C522.245544,446.717682 522.829956,448.621399 521.500671,450.232086 C519.315979,450.833832 518.087891,449.134827 516.652954,448.169067 C506.978912,441.657990 497.313843,435.131287 487.747559,428.463776 C485.004120,426.551666 482.847809,426.711884 480.091064,428.555298 C470.266083,435.125244 460.728729,442.107178 450.492737,448.092865 C432.951813,458.350220 413.916290,462.981934 393.884033,464.300201 C386.562042,464.782043 379.330627,465.973267 372.204163,467.557526 C366.717499,468.777252 363.509033,473.444000 359.871552,477.326019 C356.519196,480.903778 354.113159,485.366974 350.236084,488.359558 C348.203979,487.242523 348.304230,485.551483 348.190491,484.184998 C345.568207,452.687073 345.572968,421.454285 353.877655,390.492828 C362.598816,357.978699 382.048645,334.044403 409.604889,315.817291 C425.488983,305.310730 442.470459,296.793701 459.252411,287.911224 C469.268555,282.609772 479.149536,277.081207 488.993042,271.466034 C517.254517,255.344360 532.519653,230.199234 539.696899,199.311279 C542.188049,188.590149 543.950562,177.781052 544.167175,166.741394 C544.207703,164.673080 544.111511,162.437439 545.419983,160.619019 C547.082886,160.398636 547.503357,161.706024 548.094543,162.607895 C564.214722,187.201431 576.161987,213.554962 582.522217,242.408142 C589.628540,274.645844 586.778870,305.790955 574.263550,336.335480 C568.341370,350.789032 563.452759,365.643585 561.050781,381.247711 C558.951599,394.885101 560.606201,407.734039 566.757080,420.054016 C569.563965,425.675964 572.268921,431.348816 575.665405,438.323792 C557.678711,435.267914 541.939331,429.320312 525.723511,423.724731  z" />
				<path d="M310.437317,681.510315 C293.024139,687.373962 277.367889,695.970398 261.292664,706.082397 C262.846375,700.288879 264.314514,695.753418 265.258148,691.111328 C267.641052,679.388306 259.888702,667.853027 248.168564,665.560120 C243.324173,664.612305 239.400879,666.808899 235.912842,669.889526 C231.006577,674.222656 226.992874,679.409241 223.341385,684.733887 C217.174759,693.726013 208.315475,697.473450 198.179428,699.298828 C195.886810,699.711670 193.491577,699.826416 191.318787,700.582153 C184.720551,702.877075 179.464493,701.499878 174.214645,696.663269 C170.598038,693.331360 169.348160,689.981873 168.400558,685.304321 C166.392548,675.392334 169.859894,667.424377 174.797958,659.512817 C175.816040,657.881775 177.140732,656.271301 177.061829,653.554993 C166.182129,655.908569 155.950684,659.084412 148.933380,668.194763 C146.545090,671.295471 144.931686,671.448303 142.273651,668.894958 C138.068665,664.855591 133.743561,660.985046 130.620285,655.942322 C119.609215,638.164062 129.583923,616.846985 150.225769,613.573853 C160.351624,611.968201 170.105301,614.026733 179.981613,615.231567 C181.615997,615.430969 183.216736,615.937866 184.887405,615.355957 C185.255295,612.994751 183.367981,612.044250 182.226837,610.773865 C173.989792,601.604187 165.745209,592.439453 157.355484,583.410217 C155.165070,581.052795 155.098145,578.988647 156.468079,576.245422 C167.259369,554.636047 197.086563,548.502991 215.431671,564.199097 C221.228699,569.159058 224.209808,575.773560 226.403488,582.877197 C229.595398,593.213318 230.969223,603.974915 234.086761,614.356079 C236.454056,622.238953 241.070816,627.551147 248.412231,630.519653 C261.465576,635.797852 274.712677,640.300903 289.127594,636.595825 C291.055664,636.100281 292.960785,635.451172 294.801910,634.692017 C306.482178,629.876587 308.648987,625.661194 307.266785,613.158508 C306.006989,601.763000 303.764313,590.448120 303.726685,578.942078 C303.637115,551.553772 329.432953,528.235962 356.673676,530.486816 C369.088837,531.512695 379.756561,536.638733 389.967438,543.018982 C399.386505,548.904358 408.188141,555.692200 417.629944,563.168274 C412.815094,566.446655 408.614349,569.298401 404.422333,572.162903 C392.430054,580.357422 382.156952,590.258850 375.239288,603.144836 C364.642395,622.884338 364.098969,643.522888 370.577423,664.624146 C371.553833,667.804382 372.595825,670.964417 373.563782,674.147095 C373.698944,674.591614 373.582458,675.112549 373.582458,676.592224 C352.196289,672.832947 331.279022,674.664612 310.437317,681.510315  z" />
				<path d="M234.503510,234.519226 C254.038986,265.295105 281.973511,285.423187 313.981415,300.613220 C329.682983,308.064728 346.140381,313.387299 362.971222,317.605438 C364.412933,317.966736 365.958801,318.063385 366.911316,319.779419 C366.738037,320.251831 366.636780,320.940491 366.277893,321.446381 C356.526825,335.191101 348.043701,349.708130 340.102386,364.547363 C338.902405,366.789734 337.347260,367.468384 334.903564,367.442719 C321.407013,367.300690 307.908295,367.208374 294.411957,367.313019 C290.905334,367.340149 289.014130,365.972046 288.581573,362.647217 C287.248566,352.400757 281.065338,346.910492 271.638855,343.443420 C261.345581,339.657501 251.436035,334.827637 241.951492,329.187439 C232.374527,323.492279 227.596130,314.172943 222.833817,304.784668 C221.855148,302.855316 220.871002,300.909576 220.124329,298.884766 C214.657974,284.061279 203.766083,275.557861 188.888794,271.253143 C180.919846,268.947296 180.465927,268.544861 181.215393,260.561646 C182.758118,244.128540 173.589691,233.900574 161.538589,225.470108 C150.435287,217.702667 137.541260,214.128189 124.428894,211.364441 C121.340973,210.713593 118.292816,209.867828 115.196465,209.265396 C113.021126,208.842133 111.485466,207.658875 110.699242,205.709686 C107.297585,197.276443 101.421356,191.750244 92.438934,189.679001 C91.520569,189.467270 90.536232,188.975906 90.057228,187.146317 C101.733253,178.049652 115.495842,171.795731 128.310730,164.058441 C127.019043,161.366516 124.807304,160.737488 122.978783,159.739502 C110.805611,153.095444 103.298813,142.594238 98.121910,130.096008 C96.833305,126.985054 97.242302,125.032059 100.627953,123.354988 C108.818550,119.297821 116.527260,114.258171 125.703285,112.405121 C135.829559,110.360176 146.627747,114.923660 151.923264,123.725304 C155.136749,129.066391 157.276520,134.942978 158.483292,140.926254 C160.109619,148.989777 165.437225,152.913666 173.088577,156.221481 C174.929520,139.906113 180.694778,125.314583 190.463226,111.302010 C199.508362,118.833435 210.065247,124.031380 215.633102,134.616776 C220.240128,143.375427 217.889053,152.911560 217.640579,162.151672 C217.114334,181.722427 217.295410,201.182907 226.168610,219.315506 C228.653595,224.393631 231.580276,229.255600 234.503510,234.519226  z" />
				<path d="M495.568359,233.636688 C480.120850,244.475494 462.762390,248.768600 444.818207,251.293350 C421.881683,254.520554 398.673187,254.075027 375.656403,256.295654 C365.594757,257.266357 365.566071,257.065033 362.339661,247.134766 C361.834961,245.581421 361.454102,243.987823 360.902954,242.006577 C365.958221,240.180603 371.007568,240.669373 375.857361,240.049820 C381.130646,239.376175 386.413300,238.890259 391.647308,237.852005 C404.104858,235.380829 412.616058,228.448486 417.136261,216.474976 C422.788818,201.501846 424.144318,186.639755 415.956329,172.173584 C409.384430,160.562698 397.036713,155.178482 383.777588,156.769043 C371.432190,158.250046 359.865967,162.508972 347.995453,165.705811 C345.823914,166.290619 343.654144,167.482269 340.617584,166.068527 C345.359344,154.197464 348.528717,141.937607 362.914581,136.937958 C386.335846,128.798172 409.501648,119.903862 432.640839,110.979370 C446.649506,105.576401 460.153381,108.473312 473.721161,112.281021 C480.131317,114.079994 486.537048,115.820435 493.081787,117.114807 C501.135376,118.707596 508.575287,117.760239 515.544006,113.259125 C521.372803,109.494286 527.309509,105.896461 533.856201,101.814522 C536.232666,110.942375 538.438599,119.373894 538.234619,128.218018 C538.207520,129.391983 537.173950,130.622696 536.409912,131.685928 C533.009521,136.417831 529.945496,141.477661 526.003723,145.715683 C518.606384,153.669052 518.414185,162.915161 519.717346,172.755264 C520.939575,181.985168 522.120300,191.246063 520.874939,200.583420 C519.008057,214.580948 508.706879,222.609879 499.128876,231.127930 C498.140503,232.006943 496.954376,232.663635 495.568359,233.636688  z" />
				<path d="M304.008606,407.875366 C312.181213,406.833099 319.346008,403.505493 326.931580,401.680573 C328.702301,404.631409 327.419067,407.293274 327.240631,409.801605 C326.057312,426.438141 325.768860,443.073242 327.095428,459.702209 C327.467194,464.362335 325.937958,466.051178 321.125214,466.483948 C304.721069,467.958954 289.034363,464.421539 273.414978,460.364899 C264.403351,458.024414 255.406281,455.499115 246.632828,452.404419 C236.587006,448.860962 227.301285,450.404572 218.238266,455.132843 C210.269821,459.290070 202.432541,463.698639 194.466507,467.860626 C189.160736,470.632690 188.531998,470.209229 187.591949,464.197327 C186.949966,460.091614 186.560776,455.916412 185.532440,451.907227 C183.318588,443.276093 177.909866,440.420013 169.369110,443.015808 C165.832352,444.090790 162.212967,445.438599 159.656433,447.987579 C151.267685,456.351776 140.958893,459.466766 129.542221,460.243805 C125.908539,460.491150 122.263603,461.116272 118.716896,461.959869 C114.364616,462.994995 112.350716,461.117340 111.980278,457.090668 C111.353424,450.276855 111.182388,443.455353 113.068390,436.768982 C115.280174,428.927612 117.430977,421.066467 119.821953,413.279572 C120.702568,410.411591 119.886887,409.049957 117.210594,407.965759 C108.891098,404.595520 100.176186,403.601898 91.329742,403.289459 C84.745644,403.056915 84.367233,402.695099 85.381104,396.330444 C86.060478,392.065613 86.898605,387.826324 87.613571,383.566864 C88.702415,377.079956 92.588928,372.945801 98.362503,370.141907 C103.939362,367.433533 109.795265,365.531433 115.710022,363.845612 C119.664330,362.718567 120.088966,360.827484 118.659966,357.253448 C115.448410,349.221100 112.586449,341.048492 109.614265,332.921234 C108.994247,331.225830 108.137161,329.543213 108.681297,327.639069 C129.742859,322.186584 143.840530,322.026001 157.389328,336.832733 C163.743164,343.776489 167.859116,352.296814 171.421417,360.905884 C178.113068,377.077759 189.393753,388.060608 205.785355,394.302460 C215.120300,397.857178 224.295380,401.918884 233.983536,404.326569 C256.915894,410.025726 280.055359,413.204803 304.008606,407.875366  z" />
				<path d="M398.834198,217.781311 C372.420135,220.725082 346.675079,226.411499 320.224396,226.683609 C304.924286,226.841019 291.252136,223.603394 279.182892,214.130402 C275.170837,210.981354 271.145020,207.849808 266.908691,204.540924 C269.858917,201.556183 273.116455,202.686966 275.872528,202.292191 C293.666168,199.743362 311.059540,195.109909 328.796722,192.329498 C337.328156,190.992126 345.905334,189.509888 354.504700,189.165680 C362.977417,188.826523 370.840698,191.877609 377.903625,196.677521 C385.248413,201.668961 391.521698,207.880310 397.702423,214.188507 C398.588318,215.092651 399.860565,215.936646 398.834198,217.781311  z" />
			</g>
		</svg>
	),
	empathize: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path fill="none" d="M0 0h24v24H0z"></path>
			<path d="M18.3643 10.9792C19.9264 12.5413 19.9264 15.0739 18.3643 16.636L12.7075 22.2929C12.317 22.6834 11.6838 22.6834 11.2933 22.2929L5.63642 16.636C4.07432 15.0739 4.07432 12.5413 5.63642 10.9792C7.19851 9.41709 9.73117 9.41709 11.2933 10.9792L11.9997 11.6856L12.7075 10.9792C14.2696 9.41709 16.8022 9.41709 18.3643 10.9792ZM7.05063 12.3934C6.26958 13.1744 6.26958 14.4408 7.05063 15.2218L12.0004 20.1716L16.9501 15.2218C17.7312 14.4408 17.7312 13.1744 16.9501 12.3934C16.1691 11.6123 14.9027 11.6123 14.1203 12.3948L11.9983 14.5126L9.87906 12.3934C9.09801 11.6123 7.83168 11.6123 7.05063 12.3934ZM12.0004 1C14.2095 1 16.0004 2.79086 16.0004 5C16.0004 7.20914 14.2095 9 12.0004 9C9.79124 9 8.00038 7.20914 8.00038 5C8.00038 2.79086 9.79124 1 12.0004 1ZM12.0004 3C10.8958 3 10.0004 3.89543 10.0004 5C10.0004 6.10457 10.8958 7 12.0004 7C13.1049 7 14.0004 6.10457 14.0004 5C14.0004 3.89543 13.1049 3 12.0004 3Z"></path>
		</svg>
	),
	tent: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor">
			<path fill="none" d="M0 0h24v24H0z"></path>
			<path d="M22.1034 19L12.8659 3.00017C12.7782 2.84815 12.6519 2.72191 12.4999 2.63414C12.0216 2.358 11.41 2.52187 11.1339 3.00017L1.89638 19H1V21C8.33333 21 15.6667 21 23 21V19H22.1034ZM7.59991 19.0002H4.20568L11.9999 5.50017L19.7941 19.0002H16.4001L12 11L7.59991 19.0002ZM12 15.1501L14.1175 19H9.88254L12 15.1501Z"></path>
		</svg>
	),
}

export default icons
